<div class="flex flex-column" [ngClass]="theme">
    <span class="title" [ngClass]="{'text-left': position == 'left', 'text-center': position == 'center'}">{{ title }}</span>
    <span class="subtitle" [ngClass]="{'text-left': position == 'left', 'text-center': position == 'center'}">{{ subtitle }}</span>
</div>
